import { MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";
import { waLink } from "@/config";

export default function WhatsAppFloat() {
  const { t } = useLang();
  return (
    <a
      href={waLink(t("wa.general"))}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="WhatsApp"
      className="fixed bottom-24 md:bottom-6 right-4 md:right-6 z-50 w-14 h-14 rounded-full bg-[#22C55E] hover:bg-[#16a34a] flex items-center justify-center shadow-lg shadow-green-900/40 transition-transform hover:scale-105"
    >
      <MessageCircle size={26} className="text-white" />
    </a>
  );
}
